export default __webpack_public_path__ + "static/media/logo-new-white.5780abb3.svg";